"use server";
import { getCookies } from "ezheaders";
async function invalidateCacheAction() {
  void (await getCookies()).delete(`__clerk_invalidate_cache_cookie_${Date.now()}`);
}
export {
  invalidateCacheAction
};
